import { LegacyCard, LegacyStack, Spinner } from "@shopify/polaris";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";

import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";

export const CSMBlock = () => {
  const [hasCsm, setHasCsm] = useState(false);
  const [csmEmail, setCsmEmail] = useState<string>("");
  const [csmFirst, setCsmFirst] = useState<string>("");
  const [csmLast, setCsmLast] = useState<string>("");
  const [csmMeetingUrl, setCsmMeetingUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getCSM();
  }, []);

  const getCSM = useCallback(async () => {
    setIsLoading(true);

    const res = await typedFrontendVendorApi.getReq(`/integrations/hubspot/owners`);

    if (res.type === "success") {
      setCsmEmail(res.body.email);
      setCsmFirst(res.body.firstName);
      setCsmLast(res.body.lastName);
      setCsmMeetingUrl(res.body?.csmMap[res.body?.firstName?.toLowerCase?.()] || "");

      setHasCsm(true);
    }

    setIsLoading(false);
  }, []);

  const CustomStyles = styled.div`
    .Polaris-LegacyCard > .Polaris-LegacyCard__Section + .Polaris-LegacyCard__Section {
      border-top: 0;
      padding-top: 0;
    }
  `;

  if (!!isLoading) {
    return (
      <LegacyCard sectioned>
        <LegacyStack alignment="center" distribution="center">
          <Spinner />
        </LegacyStack>
      </LegacyCard>
    );
  }

  if (!isLoading && !!hasCsm) {
    return (
      <CustomStyles>
        <LegacyCard title={`${csmFirst} ${csmLast} is your CSM`}>
          <LegacyCard.Section>
            You have access to a dedicated Client Success Manager. Think of them as your subscriptions expert
            partner, they are here to discuss strategy, optimizations, and more.
          </LegacyCard.Section>

          <LegacyCard.Section>
            <LegacyStack spacing="loose">
              <a className="Polaris-Button Polaris-Button--primary" href={`mailto:${csmEmail}`}>
                {`Email ${csmFirst}`}
              </a>
              <a className="Polaris-Button Polaris-Button--primary" href={csmMeetingUrl}>
                {`Book a meeting with ${csmFirst}`}
              </a>
            </LegacyStack>
          </LegacyCard.Section>
        </LegacyCard>
      </CustomStyles>
    );
  }
};
